<template>
  <div class="w-full h-full relative">

    <!-- <div class=""> -->
      <!-- <PhoneArea :wallpaper="require('./img/skyspace.jpg')" :maxWidth="414" class="full mx-2"> -->
        <ThankYouCanvas>
          <MenuLayout></MenuLayout>
        </ThankYouCanvas>
      <!-- </PhoneArea> -->
    <!-- </div> -->

    <!--
    <div class="democanvas">
      <ThankYouCanvas></ThankYouCanvas>
    </div>
    -->
    <!--
    <div class="democanvas">
    </div>
    -->

  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  mounted () {
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style>
.democanvas{
  width: 100%;
  max-width: 480px;
  height: 480px;
}
</style>
